/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import "../../../app/custom.scss";
import React, { useState, useEffect, Suspense } from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackArrow from "../../../assets/BackArrow.svg";
import BackArrowWhite from "../../../assets/WhiteIcons/BackArrow_White.svg";
// custom components
import { setBarConversion } from "../../../redux/actions/DisplayChart";
import { useDispatch, useSelector } from "react-redux";
import {
  setGraphData,
  setAvailablePills,
  setPreDefinedWidgetsData,
  setAggregateData,
} from "../../../redux/actions/ApiCall";

import IsEmpty from "../../utils/IsEmpty";
import {
  setSplitObj,
  setFilterObj,
  setSecondAttr,
  setFirstAttr,
  setTicketTAT,
  setTicketSimpleView,
} from "../../../redux/actions/dashboard/Welcome";
import moment from "moment";
// import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { callNotification, getCustomizedDate } from "../../../redux/constants";

import ErrorBoundary from "../../../ErrorBoundary";
import { setWelcomePage } from "../../../redux/actions/dashboard/Welcome";
import Footer from "../../layout2/footer";
import { setClearGraphDetails } from "../../../redux/actions/dashboard/Welcome";
import {
  setIsSelected,
  setupdatedGraphData,
  setWidgetList,
} from "../../../redux/actions/widget/widget";
import { setAllSelectedCheckbox } from "../../../redux/actions/widget/widget";
import { setFooterValue } from "../../../redux/actions/section/section";
import { Button, Modal } from "antd";
import { setOptionHighChart } from "../../../redux/actions/HighChart";

const DisplayChart1 = React.lazy(() =>
  import("../../workspace/DisplayChart/DisplayChart")
);

const FirstNavBar = React.lazy(() =>
  import("../../workspace/DashboardNavbar/FirstNavBar")
);
const SecondNavBar = React.lazy(() =>
  import("../../workspace/DashboardNavbar/SecondNavBar")
);
const WelcomeSection = React.lazy(() =>
  import("../WelcomePage/WelcomeSection/WelcomeSection")
);
const DeepDive = React.lazy(() => import("../DeepDive/index"));

const WelcomePage = () => {
  const history = useHistory();

  //Redux state
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  ); //all attributes title and backend names
  const config = useSelector((state) => state.apiCall.config); // get_config data

  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const aggregateLoader = useSelector((state) => state.apiCall.aggregateLoader);
  const aggregateResponse = useSelector(
    (state) => state.apiCall.aggregateResponse
  );
  const loadingConfig = useSelector((state) => state.apiCall.loaderConfig); //config loader
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const footerValue = useSelector((state) => state.Section.footerValue);
  const graphResponse = useSelector((state) => state.apiCall.graphResponse);

  const authParams = useSelector((state) => state.Authentication.authParams);

  const isModalVisible = useSelector(
    (state) => state.CreateWorkspace.isModalVisible
  );
  const welcomePage = useSelector((state) => state.Welcome.welcomePage);
  //states
  const [isVisible, setIsModalVisible] = useState(false);

  //azure app insights setup
  // const appInsights = useAppInsightsContext();
  // const metricData = {
  //   name: "React Component Engaged Time (seconds)",
  //   sampleCount: 1,
  // };
  // const additionalProperties = { "Component Name": "Workspace" };
  // appInsights.trackMetric(metricData, additionalProperties);

  //graph details
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const ticketTAT = useSelector((state) => state.Welcome.ticketTAT);
  const firstAttr = useSelector((state) => state.Welcome.graphDetail.first);
  const secondAttr = useSelector((state) => state.Welcome.graphDetail.second);
  const filterObj = useSelector((state) => state.Welcome.graphDetail.filter);
  const splitObj = useSelector((state) => state.Welcome.graphDetail.split);
  const base = useSelector((state) => state.Welcome.graphDetail.base);
  const duration = useSelector((state) => state.Welcome.graphDetail.duration);
  const graphBrands = useSelector((state) => state.Welcome.graphDetail.brands);
  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const isEditTemplate = useSelector((state) => state.Section.isEditTemplate);
  const ticketSimpleView = useSelector(
    (state) => state.Welcome.ticketSimpleView
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const selectLogicalBrandValue = useSelector(
    (state) => state?.Logicalgroup.selectLogicalBrandValue
  ); // selected brand values

  const dispatch = useDispatch();

  useEffect(() => {
    if (!("Notification" in window)) {
      // console.log("This browser does not support desktop notification");
    } else {
      Notification.requestPermission();
    }
  }, []);

  //Graph data
  const getGraphResponseData = () => {
    dispatch(setWidgetList([]));
    dispatch(setupdatedGraphData({}));
    dispatch(setIsSelected({}));
    dispatch(setAllSelectedCheckbox(false));
    dispatch(setBarConversion("bar"));
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let graphObject = {
      authParams: authParams,
      firstAttr: firstAttr,
      secondAttr: secondAttr,
      filterObj: filterObj,
      splitObj: splitObj,
      base: base,
      brands:
        graphBrands?.length > 0
          ? graphBrands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
      duration: duration ? duration : defaultDuration,
      isBrandModified: graphBrands?.length > 0 ? true : false,
    };

    let predefinedObject = {
      authParams: authParams,
      value: firstAttr,
      graphDetail: graphDetail,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      ticketTAT: ticketTAT,
      ticketSimpleView: ticketSimpleView,
    };
    if (firstAttr) {
      let errorMessage =
        "Brand list cannot be empty! Please select atleast one brand.";
      if (graphObject?.brands?.length > 0) {
        if (authParams) {
          dispatch(setTicketTAT(null, ticketTAT));
          dispatch(setTicketSimpleView(null, ticketSimpleView));

          if (graphObject?.brands?.length > 0) {
            if (
              config?.result?.schema?.Tickets?.members[firstAttr] ||
              firstAttr === "TicketTAT"
            ) {
              dispatch(setPreDefinedWidgetsData(predefinedObject));
            } else {
              dispatch(setTicketTAT(null, ticketTAT));
              dispatch(setOptionHighChart(null));
              dispatch(setGraphData(graphObject));
              dispatch(setAggregateData(graphObject));
            }
          }
        }
      } else {
        (brandlogicalgroup || brands) &&
          callNotification(errorMessage, "error");
      }
    }
  };

  window.onload = () => {
    authParams && config && getGraphResponseData();

    if (
      !footerValue?.widget &&
      !footerValue?.template &&
      !footerValue?.section &&
      !footerValue?.replaceThisWidget
    ) {
      history.push(`/dashboard`, { onGraphPage: false, section_id: null });
    }
  };

  useEffect(() => {
    getGraphResponseData();
    if (firstAttr !== null && secondAttr !== null && firstAttr === secondAttr) {
      callNotification("Please select different attributes", "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    firstAttr,
    secondAttr,
    filterObj,
    splitObj,
    base,
    authParams,
    duration,
    brands,
    graphBrands,
    brandlogicalgroup,
  ]);

  //Get available pills
  useEffect(() => {
    authParams?.category_id && getAvailablePills();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstAttr, authParams]);
  const getAvailablePills = () => {
    authParams &&
      firstAttr !== "TicketTAT" &&
      dispatch(setAvailablePills(authParams, firstAttr));
  };
  const handleCancelYes = () => {
    // PIN DEV OLD AWA CODE
    footerValue?.dashboard
      ? history.push("/dashboard", { isGraph: true })
      : isEditTemplate
      ? history.push(`/edit-dashboard/${sectionDetails?.template_id}`)
      : history.push("/create-dashboard");
    dispatch(setClearGraphDetails());
    dispatch(setWelcomePage(true));
    dispatch(setAllSelectedCheckbox(false));
    dispatch(setWidgetList([]));
    dispatch(setupdatedGraphData({}));
    dispatch(setIsSelected({}));
    dispatch(setFooterValue({ section: false, widget: false, template: true }));
  };

  const handleModalYes = () => {
    setIsModalVisible(false);
    handleCancelYes();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const pathToDashboard = () => {
    setIsModalVisible(true);
  };
  //function to open tab with all the details
  const openWorksheet = (first, second, split, filter, base) => {
    dispatch(setWelcomePage(false));

    if (first?.length > 0) {
      dispatch(setFirstAttr(first, graphDetail));
    }
    if (second?.length > 0) {
      dispatch(setSecondAttr(second, graphDetail));
    }

    if (filter !== null) {
      dispatch(setFilterObj(filter, graphDetail));
    }
    if (!IsEmpty(split)) {
      dispatch(setSplitObj(split, graphDetail));
    }
  };

  if (welcomePage)
    // showing the graph home screen
    return loadingConfig ? (
      <div
        className="d-flex align-items-center"
        style={{
          justifyContent: "space-evenly",
          height: "calc(100vh - 4rem)",
        }}
      >
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    ) : (
      <ErrorBoundary>
        <Suspense
          fallback={
            <div
              className="d-flex align-items-center"
              style={{
                justifyContent: "space-evenly",
                height: "calc(100vh - 4rem)",
              }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          }
        >
          <WelcomeSection
            openWorksheet={openWorksheet}
            config={config}
            allAttributes={allAttributes}
          />
        </Suspense>
      </ErrorBoundary>
    );
  else {
    // showing the workspace portal
    return (
      <div className="bg__grey-light" style={{ minHeight: "100vh" }}>
        <div className="position_sticy" style={{ top: "0" }}>
          <div className="bg__white border-bottom">
            <span className="cursor-pointer align-items-center d-inline-flex portlet__title fontSize-16 font-weight500 p-15">
              <img
                onClick={() => pathToDashboard()}
                src={
                  authParams?.theme_type === "1" ? BackArrowWhite : BackArrow
                }
                alt="Back Arrow"
                style={{ maxWidth: "2rem" }}
                className="mr-1"
              />
              {footerValue?.section ? "Add New Section" : "Add New Widget"}
            </span>
          </div>
          <Modal
            title=""
            closable={false}
            visible={isVisible}
            className={`warning_popup pb-0 ${
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }`}
            footer={
              <>
                <Button onClick={() => handleCancel()} className="btn_Clear">
                  No
                </Button>
                <Button
                  type="primary"
                  className="ant-btn-primary_blue"
                  onClick={() => handleModalYes()}
                >
                  Yes
                </Button>
              </>
            }
          >
            <div className="mb-0 text_heading-Slab text-transform__none">
              Are you sure you want to exit?
            </div>
            <div className="text_regular">
              After exiting your data will be lost, whatever you have configured
              here
            </div>
          </Modal>

          <div className="pt-15 pb-0 bg__white">
            <ErrorBoundary>
              <Suspense fallback={""}>
                <FirstNavBar
                  firstAttr={firstAttr}
                  secondAttr={secondAttr}
                  splitObj={splitObj}
                  filterObj={filterObj}
                  openWorksheet={openWorksheet}
                />
              </Suspense>
            </ErrorBoundary>
          </div>

          <div className="p-15 pt-2 box-shadow-bottom bg__white pb-5 mb-15">
            <ErrorBoundary>
              <Suspense fallback={""}>
                <SecondNavBar filterObj={filterObj} />
              </Suspense>{" "}
            </ErrorBoundary>
          </div>
        </div>
        {(graphLoader && aggregateLoader) || !config ? (
          <div className="loader">
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          <ErrorBoundary>
            <Suspense
              fallback={
                <div className="loader">
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              }
            >
              <DisplayChart1
                splitFinalObj={splitObj}
                finalFilterobj={filterObj}
                firstAttr={firstAttr}
                secondAttr={secondAttr}
              />
              {brandlogicalgroup &&
                (graphResponse?.result || ticketTAT || aggregateResponse) && (
                  <Footer />
                )}
            </Suspense>
          </ErrorBoundary>
        )}
      </div>
    );
  }
};

export default WelcomePage;
